<template>
<div class="chapter">
<div class="inner_page">
<p class="P_First_Paragraph__And__Centre_Alignment__And__Spacing_After"><span><span style=" font-family: BigNoodleTitling; font-size: 3.33em;">Part One</span></span></p>
<p class="P_Print_Body__And__Centre_Alignment__And__Left_Indent"><span><span style=" font-family: BigNoodleTitling; font-size: 1.67em;">Conversations With The Dead</span></span></p>
<p class="P_Print_Body"> </p>
<p class="P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing"><span><span class="C_Current__And__Georgia">“The real problem with talking to the dead isn’t getting them to speak. It’s getting them to shut up again once they start.”<br/></span><span style=" font-style: italic; font-size: 1.00em;">- Jadim Cartarssi, Armchair Necro-psychologist</span></span></p>
<p class="P_Print_Body"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0006.vue?a131447e